module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"calculation_in_progress":"Calculation in progress","no_data":"No data as of this date"},"fr":{"calculation_in_progress":"Calcul en cours","no_data":"Pas de donnée à cette date"},"de":{"calculation_in_progress":"Berechnung läuft","no_data":"Keine Daten an diesem Datum"}}')
  delete Component.options._Ctor
}
